import footerNEW from './FooterNew'

const selfFooterNew = {
  install: Vue => {
    Vue.component('myFooterNew', footerNEW)
  }
}

export default selfFooterNew



// WEBPACK FOOTER //
// ./src/components/footerNew/index.js